import type { Model } from '@patsnap/tahiti-core';
import type { EmbodimentOutline, EmbodimentSummary } from '../apis/create-embodiment-outline-api';

export interface SpecificationEmbodimentOutlineState {
    outlines: EmbodimentOutline[];
    summary?: EmbodimentSummary; // 概要
    conclusion?: EmbodimentSummary; // 总结
    loading: boolean;
    disabled?: boolean;
}

export const SpecificationEmbodimentOutlineModel = Symbol.for('SpecificationEmbodimentOutlineModel');

export interface SpecificationEmbodimentOutlineModel extends Model<SpecificationEmbodimentOutlineState> {}
